<template>
    <div class="gp">
      <seleccion-pdf-bar :count="seleccionados.length" :loading="descargandoPdfs"
        @descargar="descargarSeleccionados()" @limpiar="seleccionados = []" />
      <!-- ═══ Resumen Cards ═══ -->
      <div class="gp__resumen">
        <div
          v-for="item in dataResumen"
          :key="item.icon"
          class="gp__resumen-card"
          :class="'gp__resumen-card--' + item.variant"
        >
          <div class="gp__resumen-icon" :class="'gp__resumen-icon--' + item.variant">
            <i :class="item.icon"></i>
          </div>
          <div class="gp__resumen-body">
            <div class="gp__resumen-valor">
              <span v-if="item.valor.euro != undefined && item.valor.euro != '0,00'">{{ item.valor.euro }} &euro;</span>
              <br v-if="item.valor.euro != undefined && item.valor.euro != '0,00' && item.valor.libra != '0,00'" />
              <span v-if="item.valor.libra != undefined && item.valor.libra != '0,00'">&pound; {{ item.valor.libra }}</span>
              <span v-if="item.valor.euro == undefined">{{ item.valor }}</span>
            </div>
            <div class="gp__resumen-label">{{ item.nombre }}</div>
          </div>
        </div>
      </div>

      <!-- ═══ Trimestres ═══ -->
      <div v-if="mostrarTrimestres" class="gp__trimestres">
        <div class="gp__trimestres-cards">
          <div
            v-for="(trimestre, index) in dataTrimestre"
            :key="index"
            class="gp__trimestre-card"
          >
            <div class="gp__trimestre-icon" :class="'gp__trimestre-icon--' + ['primary', 'success', 'warning', 'info'][index]">
              <span>T{{ index + 1 }}</span>
            </div>
            <div class="gp__trimestre-body">
              <div class="gp__trimestre-valor">{{ formatearNumero(trimestre.total) }} &euro;</div>
              <div class="gp__trimestre-label">{{ trimestre.nombre }}</div>
            </div>
          </div>
        </div>
        <div class="gp__trimestres-controls">
          <v-select
            v-model="anyoTrimestre"
            :options="anyosDisponibles"
            :clearable="false"
            class="gp__trimestre-select"
          />
          <button class="gp__btn-icon" @click="copiarTrimestres" v-b-tooltip.hover title="Copiar datos al portapapeles">
            <i class="fa-regular fa-clipboard"></i>
          </button>
        </div>
      </div>

      <!-- ═══ Contenido principal ═══ -->
      <div class="gp__main" :class="{'ocultar-div': !vistaLista && !cargando}">

        <!-- Filtros -->
        <div class="gp__filters">
          <div class="gp__filter-item">
            <label class="gp__filter-label">Pagado</label>
            <v-select v-model="pagadoSelect" :options="['Todos','Sin Pagar','Pagado']" :clearable="false"
              placeholder="Seleccionar" class="gp__filter-select" />
          </div>
          <div class="gp__filter-item">
            <label class="gp__filter-label">Desde</label>
            <div class="gp__date-wrap">
              <flat-pickr v-model="fechaDesdeSelect" class="form-control gp__date-input" />
              <button class="gp__date-clear" @click="fechaDesdeSelect = ''" title="Limpiar">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>
          <div class="gp__filter-item">
            <label class="gp__filter-label">Hasta</label>
            <div class="gp__date-wrap">
              <flat-pickr v-model="fechaHastaSelect" class="form-control gp__date-input" />
              <button class="gp__date-clear" @click="fechaHastaSelect = ''" title="Limpiar">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>
          <div class="gp__filter-item">
            <label class="gp__filter-label">Empresa</label>
            <v-select v-model="empresaSelect" :options="empresas" label="nombre" :clearable="false"
              placeholder="Seleccionar" class="gp__filter-select" />
          </div>
          <div class="gp__filter-item gp__filter-item--wide">
            <label class="gp__filter-label">Proveedor</label>
            <v-select v-model="proveedorSelect" :options="proveedores" label="nombre" :clearable="false"
              placeholder="Seleccionar" class="gp__filter-select" />
          </div>

          <div class="gp__filter-buttons">
            <button class="gp__btn-fab" @click="openModalNew()" v-b-tooltip.hover.v-success title="Nuevo gasto">
              <i class="fa-solid fa-plus"></i>
            </button>
            <button class="gp__btn-icon" @click="downloadExcell()" v-b-tooltip.hover title="Descargar Excel">
              <i class="fa-solid fa-file-excel"></i>
            </button>
            <button class="gp__btn-icon" v-b-modal.modal-347 v-b-tooltip.hover title="Modelo 347">
              <i class="fa-solid fa-file-contract"></i>
            </button>
          </div>
        </div>

        <!-- Buscador -->
        <div class="gp__search">
          <i class="fa-solid fa-magnifying-glass gp__search-icon"></i>
          <input type="text" class="gp__search-input" placeholder="Buscar gasto..." v-model="buscar" />
        </div>

        <!-- Tabla -->
        <div class="gp__table-card">
          <div class="gp__tabla-scroll">
            <b-table
              :items="formartedItems"
              :fields="columnasTable"
              class="gp__table"
              no-border-collapse
              sort-icon-left
              @sort-changed="sortChanged"
              ref="tableGastos"
              :sort-by.sync="sortBy"
              hover
            >

              <template #head(sel)>
                <b-form-checkbox :checked="todosSeleccionados" @change="seleccionarTodos" />
              </template>
              <template #cell(sel)="data">
                <b-form-checkbox v-if="data.item.tienePdf" v-model="seleccionados" :value="data.item.id" />
              </template>

              <template #cell(options)="data">
                <div class="gp__actions">
                  <span @click="editFactura(data.item)" class="gp__action gp__action--edit"
                    v-b-tooltip.hover title="Editar gasto">
                    <i class="fa-solid fa-pen-to-square"></i>
                  </span>
                  <span v-if="data.item.tienePdf" @click="previsualizarPDF(data.item)"
                    class="gp__action gp__action--view"
                    v-b-tooltip.hover title="Ver PDF">
                    <i class="fa-solid fa-eye"></i>
                  </span>
                  <span v-if="data.item.tienePdf" @click="descargarPDF(data.item)"
                    class="gp__action gp__action--pdf" :class="{ 'gp__action--pdf-otros': data.item.pdfFactura == 0 }"
                    v-b-tooltip.hover :title="data.item.pdfFactura == 0 ? 'Descargar PDF (otro)' : 'Descargar PDF factura'">
                    <i class="fa-solid fa-file-pdf"></i>
                  </span>
                  <span @click="deleteGasto(data.item.id, data.item.codigo)" class="gp__action gp__action--delete"
                    v-b-tooltip.hover.v-danger title="Eliminar gasto">
                    <i class="fa-solid fa-trash"></i>
                  </span>
                </div>
              </template>

              <template #cell(proveedor)="data">
                <span v-if="data.item.proveedor != data.item.proveedorCompleto" v-b-tooltip.hover.v-secondary :title="data.item.proveedorCompleto">{{ data.item.proveedor }}</span>
                <span v-else>{{ data.item.proveedor }}</span>
              </template>

              <template #cell(pagado)="data">
                <span v-if="data.item.fechaPagado.length == 0" class="gp__pagado gp__pagado--no" @click="clickPagado(true, data.item.id)">
                  <i class="fa-solid fa-xmark"></i>
                </span>
                <span v-else class="gp__pagado gp__pagado--si">
                  <span @click="clickPagado(false, data.item.id)" v-b-tooltip.hover.v-success :title="data.item.fechaPagado">
                    <i class="fa-solid fa-check"></i>
                  </span>
                  <span class="gp__pagado-edit" @click="editarFechaPagado(data.item)">
                    <i class="fa-solid fa-pen-to-square"></i>
                  </span>
                </span>
              </template>

              <template #cell(notas)="data">
                <span v-if='data.item.notas.length > 0' class="gp__nota-icon" v-b-tooltip.hover.v-primary :title="data.item.notas">
                  <i class="fa-regular fa-message"></i>
                </span>
              </template>

              <template #cell(total_moneda)="data">
                <span class="gp__total-moneda" v-if="data.item.moneda == null || data.item.moneda == 'EUR'">{{ data.item.total }} &euro;</span>
                <span class="gp__total-moneda" v-if="data.item.moneda == 'GBP'">&pound;{{ data.item.total }}</span>
                <span class="gp__total-moneda" v-if="data.item.moneda == 'USD'">{{ data.item.total }} $</span>
              </template>

            </b-table>
          </div>
          <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
        </div>
      </div>

        <!--<div class="app-calendar overflow-hidden border" :class="{'ocultar-div': vistaLista && !cargando }">
          <div class="row no-gutters">
         
            <div
              class="col app-calendar-sidebar flex-grow-0 overflow-hidden d-flex flex-column"
              :class="{'show': isCalendarOverlaySidebarActive}"
            >
              <calendar-sidebar :is-event-handler-sidebar-active.sync="isEventHandlerSidebarActive" v-on:openModalNew="openModalNew" />
            </div>

        
            <div class="col position-relative">
              <div class="card shadow-none border-0 mb-0 rounded-0">
                <div class="card-body pb-0">
                  <full-calendar
                    ref="refCalendar"
                    :options="calendarOptions"
                    class="full-calendar"
                  />
                </div>
              </div>
            </div>

    

              <div
              class="body-content-overlay"
              :class="{'show': isCalendarOverlaySidebarActive}"
              @click="isCalendarOverlaySidebarActive = false"
              />
              <calendar-event-handler
              v-model="isEventHandlerSidebarActive"
              :event="event"
              :clear-event-data="clearEventData"
              @remove-event="removeEvent"
              @add-event="addEvent"
              @update-event="updateEvent"
              />
            -->
            <!--
          </div>
        </div>      -->
       

        <!--INCIO MODAL NUEVO GASTO-->
        <b-modal
            id="modal-add"
            :title="tituloModal"
            centered
            size="lg"
            hide-footer
            >
            <b-row class="match-height">
                <!--PROVEEDOR-->
                <b-col cols="7">
                    <b-form-group
                    label="*Proveedor"
                    label-for="basicInput"
                    >
                    <v-select
                    v-model="inputProveedor"
                    label="nombre"
                    :options="listadoProveedores"
                    />
                    </b-form-group>
                </b-col>
                <!--EMPRESA-->
                <b-col cols="5">
                    <b-form-group
                    label="*Empresa"
                    label-for="basicInput"
                    >
                    <v-select
                    v-model="inputEmpresa"
                    label="nombre"
                    :options="empresasGastos"
                    />
                    </b-form-group>
                </b-col>
                 <!--Codigo-->
                <b-col cols="3">
                    <b-form-group
                    label="*Codigo"
                    label-for="basicInput"
                    >
                    <b-form-input
                    id="basicInput"
                    placeholder="codigo"
                    v-model="inputCodigo"
                    type="text"
                    />
                    </b-form-group>
                </b-col>
                 <!--CANTIDAD-->
                <b-col cols="2">
                    <b-form-group
                    label="*Cantidad"
                    label-for="basicInput"
                    >
                    <b-form-input
                    id="basicInput"
                    placeholder="cantidad"
                    v-model="inputCantidad"
                    type="number"
                    @wheel.prevent
                    />
                    </b-form-group>
                </b-col>
                <!--PENDIENTE-->
                <b-col cols="2">
                    <b-form-group
                    label="Pendiente"
                    label-for="basicInput"
                    >
                    <b-form-input
                    id="basicInput"
                    placeholder="pendiente"
                    v-model="inputPendiente"
                    type="number"
                    @wheel.prevent
                    />
                    </b-form-group>
                </b-col>
                <!--FECHA-->
                <b-col cols="3">
                    <b-form-group
                        label="*Fecha de factura"
                        label-for="basicInput"
                    >
                    <b-form-datepicker 
                        v-model="inputFecha" 
                        class="mb-2" 
                        today-button
                        placeholder="fecha"
                        :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit'}"
                        locale="es"
                    ></b-form-datepicker>
                    </b-form-group>
                </b-col>
                <!--Pazo-->
                <b-col cols="2">
                    <b-form-group
                    label="Plazo"
                    label-for="basicInput"
                    >
                      <b-form-input
                      id="basicInput"
                      placeholder="plazo"
                      v-model="inputPlazo"
                      type="number"
                      @wheel.prevent
                      />
                    </b-form-group>
                </b-col>
                <!--Monedas-->
                <b-col cols="12" style="margin-top: -25px;">
                  <b-form-group
                    label="Moneda"
                    label-for="currencyRadio"
                  >
                    <b-form-radio-group
                      id="currencyRadio"
                      v-model="selectedCurrency"
                      :options="currencyOptions"
                      name="currency-options"
                      buttons
                      button-variant="outline-primary"                      
                    />
                  </b-form-group>
                </b-col>
                <!--Notas-->
                <b-col cols="12">
                    <b-form-group
                    label="Notas"
                    label-for="basicInput"
                    >
                    <b-form-input
                    id="basicInput"
                    placeholder="notas"
                    v-model="inputNotas"
                    type="text"
                    />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    label="Subir pdf"
                    label-for="basicInput"
                    >
                      <b-form-file
                      accept=".pdf"
                      v-model="inputPDF"
                      placeholder="Seleccionar pdf..."
                      drop-placeholder="Suelta el pdf aqui..."
                    />
                  </b-form-group>
                    <b-form-checkbox 
                        v-model="inputPdfFactura"
                        name="check-button"
                        switch
                        inline
                        >
                    PDF Factura
                    </b-form-checkbox>
                </b-col>

             </b-row>

             <b-table
              v-if="inputProveedor != null && inputProveedor != ''"
                :items="listadoPedidosMostrar"
                :fields="columnasTablePedidos"
                class="table table-borderless table-pedidos"
                no-border-collapse
                sort-icon-left
                ref="tablePedidos"
              >

              <template #cell(pedido)="data">
                  <span v-if="data.item.fechaPedido.length == 0" style="color: red"><i class="fa-solid fa-xmark"></i></span>
                  <span v-else> <span style="color: green" ><i class="fa-solid fa-check"></i> {{data.item.fechaPedido}}</span></span>                                    
              </template>

              <template #cell(checking)="data">
                <b-form-checkbox
                    :id="'checkbox-'+data.item.check"
                    v-model="data.item.check"
                  >
                  </b-form-checkbox>
              </template>

              <template #cell(options)="data">           
                <span @click="data.toggleDetails">
                      <i v-if="data.detailsShowing" class="fa-solid fa-arrow-up button-details"></i>
                      <i v-else class="fa-solid fa-arrow-down button-details"></i> 
                </span>
              </template>

              <template #row-details="row">
                    <div class="row">
                        <div class="col-1"></div>
                        <div class="col-4">
                            <b-table
                                :items="row.item.listaMateriales.filter(mat => mat.visible)"
                                :fields="columnasMateriales"
                                class="table table-borderless"
                                no-border-collapse
                                sort-icon-left
                                >

                                <template #cell(udrecibido)="data">           
                                  <b-form-input
                                      placeholder=""                                      
                                      type="number"
                                      v-model.lazy="data.item.cantidadFacturada"
                                      @wheel.prevent
                                      style="width: 55px;"
                                      />
                                </template>

                            </b-table>
                        </div>
                    </div>
                </template>

            </b-table>

            <div style="text-align: center; margin-top: 10px">
                <b-button variant="outline-success" class="btn-icon"  @click="guardarPediente()">
                    {{textBotonGuardar}}
                </b-button>
            </div>

        </b-modal>
        <!--FIN MODAL NUEVO GASTO-->

        <div>
          <!-- Modal de edición -->
          <b-modal
            id="modal-fecha-pagado"
            ref="modalFechaPagado"
            title="Seleccionar nueva fecha de pago"
            ok-title="Guardar"
            cancel-title="Cancelar"
            @ok="guardarFechaPagado"
            @shown="focusInput"
            centered
            size="sm"
            ok-variant="primary"
            cancel-variant="outline-secondary"
          >
            <b-form-group label="Fecha (DD-MM-YYYY)" label-for="input-fecha">
              <input
                id="input-fecha"
                class="form-control"
                type="date"
                v-model="nuevaFechaPagado"
                required
              />
            </b-form-group>
          </b-modal>
        </div>

        <!-- MODAL PREVISUALIZAR PDF -->
        <b-modal
          :visible="!!pdfPreviewUrl"
          :title="pdfPreviewTitulo"
          size="xl"
          centered
          hide-footer
          @hidden="cerrarPreviewPDF"
        >
          <iframe v-if="pdfPreviewUrl" :src="pdfPreviewUrl" class="gp__pdf-preview"></iframe>
        </b-modal>

        <!-- MODAL MODELO 347 -->
        <b-modal
          id="modal-347"
          :title="'Modelo 347 - ' + anyo347"
          size="xl"
          centered
          hide-footer
          body-class="modal-347-body"
          @show="calcular347"
        >
          <b-row class="mb-2 align-items-center">
            <b-col md="2">
              <v-select
                v-model="anyo347"
                :options="anyosDisponibles"
                :clearable="false"
              />
            </b-col>
            <b-col md="auto">
              <b-button variant="outline-primary" size="sm" @click="copiar347" v-b-tooltip.hover title="Copiar al portapapeles">
                <i class="fa-regular fa-clipboard"></i> Copiar
              </b-button>
              <b-button variant="outline-success" size="sm" class="ml-1" @click="descargar347CSV" v-b-tooltip.hover title="Descargar CSV">
                <i class="fa-solid fa-download"></i> CSV
              </b-button>
            </b-col>
            <b-col class="text-right">
              <span class="font-weight-bold">{{ data347.length }} proveedores</span>
            </b-col>
          </b-row>

          <b-table
            :items="data347"
            :fields="[
              { key: 'nombre', label: 'Proveedor', sortable: true },
              { key: 'cif', label: 'CIF', sortable: true },
              { key: 'trimestre1', label: 'T1', sortable: true, class: 'text-right' },
              { key: 'trimestre2', label: 'T2', sortable: true, class: 'text-right' },
              { key: 'trimestre3', label: 'T3', sortable: true, class: 'text-right' },
              { key: 'trimestre4', label: 'T4', sortable: true, class: 'text-right' },
              { key: 'total', label: 'Total', sortable: true, class: 'text-right' }
            ]"
            small
            striped
            hover
            responsive
            foot-clone
          >
            <template #cell(trimestre1)="data">
              {{ formatearNumero(data.item.trimestre1) }} €
            </template>
            <template #cell(trimestre2)="data">
              {{ formatearNumero(data.item.trimestre2) }} €
            </template>
            <template #cell(trimestre3)="data">
              {{ formatearNumero(data.item.trimestre3) }} €
            </template>
            <template #cell(trimestre4)="data">
              {{ formatearNumero(data.item.trimestre4) }} €
            </template>
            <template #cell(total)="data">
              <strong>{{ formatearNumero(data.item.total) }} €</strong>
            </template>

            <template #foot(nombre)>
              <strong>TOTAL</strong>
            </template>
            <template #foot(cif)><span></span></template>
            <template #foot(trimestre1)>
              <div class="text-right"><strong>{{ formatearNumero(total347.t1) }} €</strong></div>
            </template>
            <template #foot(trimestre2)>
              <div class="text-right"><strong>{{ formatearNumero(total347.t2) }} €</strong></div>
            </template>
            <template #foot(trimestre3)>
              <div class="text-right"><strong>{{ formatearNumero(total347.t3) }} €</strong></div>
            </template>
            <template #foot(trimestre4)>
              <div class="text-right"><strong>{{ formatearNumero(total347.t4) }} €</strong></div>
            </template>
            <template #foot(total)>
              <div class="text-right"><strong>{{ formatearNumero(total347.total) }} €</strong></div>
            </template>
          </b-table>
        </b-modal>
        <!-- FIN MODAL MODELO 347 -->

        </div>
    </template>
    
    <script>
    import axios from '@axios'
    import SeleccionPdfBar from '@/components/SeleccionPdfBar.vue'
    import { descargarZip, nombreArchivo } from '@/libs/descargarZip'
    /*import VueApexCharts from 'vue-apexcharts'*/
    import { BTable , BFormCheckbox, BFormInput, BFormGroup, BModal, BCardText, BCardBody, BCard, BRow, BCol} from 'bootstrap-vue'
    // import BCardCode from '@core/components/b-card-code'
    import { $themeColors } from '@themeConfig'
    import { useTimeout } from '@vueuse/shared'
    import vSelect from 'vue-select'
    import { find, forEach } from 'postcss-rtl/lib/affected-props'
    import flatPickr from 'vue-flatpickr-component'

    import FullCalendar from '@fullcalendar/vue'

    import store from '@/store'
    import { onUnmounted } from '@vue/composition-api'
    import calendarStoreModule from './calendarStoreModule'
    import CalendarSidebar from './calendar-sidebar/CalendarSidebar.vue'
    import CalendarEventHandler from './calendar-event-handler/CalendarEventHandler.vue'
    import useCalendar from './useCalendar'

    import useCalendarSidebar from './calendar-sidebar/useCalendarSidebar'
    
      export default {
        components: {
            SeleccionPdfBar,
            BFormCheckbox,
            BTable,
            BFormInput,
            BFormGroup,
            BCardText,
            BCardBody,
            BCard,
            BRow,
            BCol,
            vSelect,
            flatPickr,
            FullCalendar,
            CalendarSidebar,
            CalendarEventHandler,
        },
        data () {
          return {
            sortBy: "fechaVencimiento",
            seleccionados: [],
            descargandoPdfs: false,
            columnasTable: [
            { key: "sel", label: "", sortable: false, thStyle: { width: "32px" } },
            {
              key: "options",
              label: "",
              sortable: false,
              thStyle: { width: "7%" },
            },
            {
              key: "nombreEmpresa",
              label: "Empresa",
              sortable: true,
            },
            {
              key: "proveedor",
              label: "Proveedor",
              sortable: true,
            },            
            {
              key: "codigo",
              label: "Codigo",
              sortable: true,
            },            
            {
              key: "recibido",
              label: "Recibido",
              sortable: true,
            },,{
              key: "fechaFactura",
              label: "Fecha",
              sortable: true,
            },{
              key: "total_moneda",
              label: "Total",
              sortable: true,
            },{
              key: "pendiente",
              label: "Falta",
              sortable: true,
            },{
              key: "fechaVencimiento",
              label: "Vencimiento",
              sortable: true,
            },{
              key: "plazo",
              label: "Plazo",
              sortable: true,
            },{
              key: "notas",
              label: "Notas",
              sortable: true,
            },{
              key: "pagado",
              label: "",
              sortable: false,
            }],
            columnasTablePedidos: [
            {
              key: "checking",
              label: "",
              sortable: false,
              thStyle: { width: "7%" },
            },
            {
              key: "options",
              label: "",
              sortable: false,
              thStyle: { width: "7%" },
            },
            {
              key: "codigo",
              label: "Codigo",
              sortable: true,
            },
            {
              key: "totalMateriales",
              label: "Materiales",
              sortable: true,
            },
            {
              key: "fecha",
              label: "Fecha",
              sortable: true,
            },{
              key: "pedido",
              label: "Pedido",
              sortable: true,
            }],
            columnasMateriales: [          
            {
              key: "nombre",
              label: "Nombre",
              sortable: false,
            },
            {
              key: "color",
              label: "Color",
              sortable: false,
            },
            {
              key: "cantidad",
              label: "UD",
              sortable: false,
            },{
              key: "udrecibido",
              label: "Recibido",
              sortable: true,
            }],
            buscar: "",
            pdfPreviewUrl: null,
            pdfPreviewTitulo: '',
            textoProveedor: {},
            countItemView: 100,
            nextScrollItemView: 40,
            defaultItemView: 100,
            lastSort: null,
            facturasBusqueda: [],
            allFacturasBusqueda: [],
            listadoFacturas: [],
            fechaDesdeSelect: '',
            fechaHastaSelect: '',
            categorias: [],
            categoriaSelect: [],
            pagadoSelect: 'Todos',
            empresaSelect: '',
            proveedorSelect: '',
            clients: [],
            empresas: [],
            dataResumen: [{icon:'fa-solid fa-file-invoice-dollar', nombre: 'Gastos', valor: 22, variant: 'primary', moneda: ''},
                          {icon:'fa-solid fa-money-bill-transfer', nombre: 'Pendiente', valor: 22, variant: 'danger', moneda: '€'},
                          {icon:'fa-solid fa-hand-holding-dollar', nombre: 'Pagado', valor: 22, variant: 'success', moneda: '€'},
                          {icon:'fa-solid fa-money-bill', nombre: 'Total', valor: 22, variant: 'info', moneda: '€'},],
            tituloModal: "Añadir gastos",
            listadoProveedores: [],
            proveedores: [],
            textBotonGuardar: "Crear nuevo",
            inputProveedor: "",
            inputCodigo: "",
            inputCantidad: 0,
            inputFecha: "",
            inputFechaVencimiento: "",
            inputPlazo: "",
            inputNotas: "",
            inputEmpresa: "",
            inputPendiente: "",
            inputPdfFactura: true,
            empresasGastos: [],
            idEdit: 0,
            inputPDF: [],
            base64PDF: '',
            itemSelect: null,
            inputFechaNueva: '',
            vistaLista: true,
            listadoPedidos: [],
            listadoPedidosMostrar: [],
            nuevoGasto: true,
            cargando: true,
            selectedCurrency: 'EUR',
            currencyOptions: [
              { text: 'Euro (€)', value: 'EUR' },
              { text: 'Libra (£)', value: 'GBP' },
              { text: 'Dólar ($)', value: 'USD' }
            ],
            tiposCambioAEuro: {
              EUR: 1,
              USD: 0.85,
              GBP: 1.16
            },
            nuevaFechaPagado: '',
            facturaActual: null,
            mostrarTrimestres: false,
            dataTrimestre: null,
            anyoTrimestre: new Date().getFullYear(),
            anyosDisponibles: [2021, 2022, 2023, 2024, 2025, 2026],
            data347: [],
            anyo347: new Date().getFullYear()
          }
        },
        computed: {
          formartedItems () {
            if (!this.facturasBusqueda) return []
            return this.facturasBusqueda.map(item => {
              item._rowVariant  = this.getVariant(item.fechaVencimiento, item.fechaPagado)
              return item
            })
          },
          todosSeleccionados() {
            const ids = this.formartedItems.filter(i => i.tienePdf).map(i => i.id);
            return ids.length > 0 && ids.every(id => this.seleccionados.includes(id));
          },
          total347() {
            return this.data347.reduce((acc, p) => {
              acc.t1 += p.trimestre1;
              acc.t2 += p.trimestre2;
              acc.t3 += p.trimestre3;
              acc.t4 += p.trimestre4;
              acc.total += p.total;
              return acc;
            }, { t1: 0, t2: 0, t3: 0, t4: 0, total: 0 });
          }
        },
        methods:{
          formatearNumero(numero) {
            return numero.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
          },
          getVariant (fecha, fechaPagado) {

            if(fecha == '' || fechaPagado.length > 0)
              return '';

            const fechaActual = new Date();
            const fechaObjetivo = new Date(fecha);
            const diferenciaMilisegundos = fechaObjetivo - fechaActual;
            const diasFaltantes = Math.ceil(diferenciaMilisegundos / (1000 * 60 * 60 * 24));

            //Vencida - Rojo
            //15 al 1 - Naranja o Amarillo
            //16 en adelante - Verde

            if(diasFaltantes > 15)
              return 'success';
            else if(diasFaltantes > 0)
              return 'warning';
            else if(diasFaltantes <= 0)
              return 'danger';            

           
          },
          loadItems(){

            axios.post("/uso", {seccion:"gastosProveedor"});
    
             function ponerMoneda(total, moneda){
              if(moneda == "€")
                return total +''+ moneda
              else
                return moneda +''+ total;      
            }

              axios
                .get("/shopify/exchange/USD")
                .then(response => {
                    return response.data;
                })
                .then(res => {
                  this.tiposCambioAEuro.USD = res.rates.EUR;
                });

              axios
                .get("/shopify/exchange/GBP")
                .then(response => {
                    return response.data;
                })
                .then(res => {
                  this.tiposCambioAEuro.GBP = res.rates.EUR;
                });

                Promise.all([
                    axios.get("/finanzas/empresas"),
                    axios.get("/proveedores"),
                    axios.get("/finanzas/gastos"),
                    axios.get("/materiales/pedidos")
                ]).then(responses => {
                    const [empresasResponse, proveedoresResponse, gastosResponse, pedidosResponse] = responses;

                    // Empresas
                    const empresasData = empresasResponse.data;
                    this.empresasGastos = JSON.parse(JSON.stringify(empresasData));
                    this.empresas = empresasData;
                    this.empresas.unshift({id: 0, nombre: 'Todas'})
                    this.inputEmpresa = this.empresas[1];

                    // Proveedores
                    const proveedoresData = proveedoresResponse.data;
                    this.listadoProveedores = proveedoresData;
                    // Texto de búsqueda por proveedor (antes de que nickname sobrescriba nombre)
                    this.textoProveedor = {};
                    proveedoresData.forEach(p => {
                      this.textoProveedor[p.id] = [p.nombre, p.nickname, p.cif, p.email, p.contacto, p.telefono, p.web, p.pais, p.direccion]
                        .filter(Boolean).join(' ').toLowerCase();
                    });
                    this.listadoProveedores.sort((a, b) => a.nombre.localeCompare(b.nombre));
                    this.listadoProveedores.forEach(proveedor => {
                      if (proveedor.nickname != '') {
                          proveedor.nombre = proveedor.nickname;
                      }
                    });
                    this.proveedores = JSON.parse(JSON.stringify(proveedoresData));
                    this.proveedores.sort((a, b) => a.nombre.localeCompare(b.nombre));
                    this.proveedores.unshift({id: 0, nombre: 'Todos'})

                    // Defaults antes de cargar filtro
                    if(this.empresaSelect == '')
                      this.empresaSelect = this.empresas[0];
                    if(this.proveedorSelect == '')
                      this.proveedorSelect = this.proveedores[0];

                    // Restaurar filtros guardados (usa referencias del array real)
                    this.cargarFiltro();

                    // Manejo de la respuesta de gastos
                    this.listadoFacturas = gastosResponse.data;
                    this.listadoFacturas = this.listadoFacturas.sort((a, b) => a.fechaVencimiento - b.fechaVencimiento);

                    //console.log(this.listadoFacturas);

                    // Manejo de la respuesta de pedidos
                    this.listadoPedidos = pedidosResponse.data;
                    this.listadoPedidos.sort((a, b) => a.fecha - b.fecha);

                    // Aquí puedes llamar a una función que deseas ejecutar después de que se completen ambas solicitudes
                    this.listadoFacturas.forEach(gasto => {
                      gasto.proveedorCompleto = gasto.proveedor;
                      if(gasto.proveedor.length > 20)
                      {
                        gasto.proveedor = gasto.proveedor.substring(0, 20) + "...";
                      }



                      let proveedorFind = this.listadoProveedores.find(prov => prov.id == gasto.idProveedor);
                      if(proveedorFind)
                      {
                        gasto.cifProveedor = proveedorFind.cif;
                        if(proveedorFind.nickname != '')
                          gasto.proveedor = proveedorFind.nickname;
                      }
                        

                      let pedidosAsociados = this.listadoPedidos.filter(pedido => pedido.idGasto == gasto.id);

                      let totalPedido = 0;
                      let totalRecibido = 0;

                      pedidosAsociados.forEach(pedido => {
                        pedido.listaMateriales.forEach(material => {
                          totalPedido += parseInt(material.cantidad);
                          totalRecibido += parseInt(material.cantidadRecibida);
                        });
                      });

                      if(totalPedido != 0)
                        gasto.recibido = totalPedido +' / '+totalRecibido;
                      else
                        gasto.recibido = '';
                      
                    });

                    //console.log(this.listadoFacturas);

                    this.facturasBusqueda = this.listadoFacturas;
                    this.buscarFuncion();
                }).catch(error => {
                    console.error("Error al realizar las solicitudes: ", error);
                });

    
          },
          openModalNew(){
            this.nuevoGasto = true;
            //this.refetchEvents();
            this.idEdit = 0;
            this.inputProveedor = "";
            this.inputFecha = "";
            this.inputCodigo = "";
            this.inputCantidad = "";
            this.inputFechaVencimiento = "";
            this.inputPlazo = "";
            this.inputNotas = "";
            this.inputPendiente = "";
            this.inputPdfFactura = true;
            this.textBotonGuardar = "Crear nuevo";
            this.itemSelect = null;
            this.selectedCurrency = 'EUR';
            this.$bvModal.show('modal-add');
            
          },
          editFactura(item){
            this.nuevoGasto = false;
            this.idEdit = item.id;
            this.textBotonGuardar = "Guadar cambios";
            this.inputProveedor = this.listadoProveedores.find(element => element.id === item.idProveedor);
            this.inputEmpresa = this.empresas.find(element => element.id === item.idEmpresa);
            this.inputCodigo = item.codigo;
            this.inputCantidad = item.total;
            this.inputFecha = item.fechaFactura;
            this.inputFechaVencimiento = item.fechaVencimiento;
            this.inputPlazo = item.plazo;
            this.inputNotas = item.notas;
            this.inputPendiente = item.pendiente;
            this.selectedCurrency = item.moneda || 'EUR';
            //console.log(item.moneda);
            if(item.pdfFactura == 1)
              this.inputPdfFactura = true;
            else
              this.inputPdfFactura = false;
            this.itemSelect = item;
            this.$bvModal.show('modal-add');
          },
          deleteGasto(id, codigo){
            this.$swal({
              title: 'Estas seguro que quieres borrar la factura: ' + codigo,
              icon: 'error',
              showCancelButton: true,
              //html: `<input type="text" id="motivo" class="swal2-input" placeholder="Motivo">`,
              confirmButtonText: 'Si, borrar',
              cancelButtonText: 'No',
              customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ml-1',
              },
              buttonsStyling: false,
            }).then(result => {

              if(result.isConfirmed)
              {

                axios
                .delete("/finanzas/gastos/"+id)
                .then(response => {
                  return response.data;
                })
                .then(res => {
                    //this.listadoFacturas
                    this.$swal({
                        icon: 'success',
                        title: 'La factura se ha borrado correctamente: ' + codigo,
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                    })

                    this.listadoFacturas = this.listadoFacturas.filter(item => item.id !== id);
                    this.facturasBusqueda = this.facturasBusqueda.filter(item => item.id !== id);
                    this.calcularResumen();
                    this.buscarFuncion();
                  }).
                  catch(execption => {
                    console.log(execption);
                    this.$swal({
                        icon: 'danger',
                        title: 'Se ha producido un error al borrar la factura.' ,
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                    })
                  });

              }

            })
          },
          loadMore() {
            this.countItemView += this.nextScrollItemView;
            this.buscarFuncion();
          },
          sortChanged(e) {
            this.lastSort = e;
            this.buscarFuncion();
          },
          convertToBase64() {
            return new Promise((resolve) => {
              if (this.inputPDF instanceof Blob) {
                const fileReader = new FileReader();

                fileReader.onload = () => {
                  this.base64PDF = fileReader.result;
                  resolve();
                };

                // Leer el contenido del archivo PDF como una URL de datos
                fileReader.readAsDataURL(this.inputPDF);
              } else {
                resolve();
              }
            });
          },
          // Devuelve el PDF (data URL) del gasto, cacheado en data.pdf
          obtenerPdf(data) {
            if (data.pdf && data.pdf.length > 0)
              return Promise.resolve(data.pdf);
            return axios.get("/finanzas/gastos/pdf/"+data.id).then(response => (data.pdf = response.data));
          },
          seleccionarTodos(marcar) {
            this.seleccionados = marcar ? this.formartedItems.filter(i => i.tienePdf).map(i => i.id) : [];
          },
          async descargarSeleccionados() {
            this.descargandoPdfs = true;
            const archivos = [];
            let fallidos = 0;
            try {
              for (const id of this.seleccionados) {
                const item = this.listadoFacturas.find(f => f.id === id);
                if (!item) continue;
                try {
                  const pdf = await this.obtenerPdf(item);
                  archivos.push({
                    nombre: nombreArchivo(item.proveedor.replaceAll(' ', '_') + '_' + item.codigo) + '.pdf',
                    contenido: await (await fetch(pdf)).blob(),
                  });
                } catch (e) {
                  console.error('Error obteniendo PDF del gasto ' + id + ':', e);
                  fallidos++;
                }
              }
              if (archivos.length) {
                await descargarZip('gastos-proveedor_' + new Date().toISOString().slice(0, 10) + '.zip', archivos);
                this.seleccionados = [];
              }
              if (fallidos)
                this.$bvToast.toast(fallidos + ' PDF no se pudieron incluir en el zip', { title: 'Aviso', variant: 'warning', solid: true });
            } catch (e) {
              console.error('Error generando zip:', e);
              this.$bvToast.toast('Error al generar el zip', { title: 'Error', variant: 'danger', solid: true });
            } finally {
              this.descargandoPdfs = false;
            }
          },
          descargarPDF(data) {
            return this.obtenerPdf(data).then(pdf => {
              let textoProveedor = data.proveedor.replaceAll(' ','_');
              const link = document.createElement('a');
              link.href = pdf;
              link.download = textoProveedor + '_' +data.codigo + '.pdf';
              link.target = '_blank'; // Abre el enlace en una nueva pestaña
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            });
          },
          async previsualizarPDF(data) {
            try {
              const pdf = await this.obtenerPdf(data);
              // Blob URL: Chrome no deja mostrar data: URLs grandes en un iframe
              const blob = await (await fetch(pdf)).blob();
              this.pdfPreviewTitulo = data.proveedor + ' · ' + data.codigo;
              this.pdfPreviewUrl = URL.createObjectURL(blob.type ? blob : new Blob([blob], { type: 'application/pdf' }));
            } catch (e) {
              console.error('Error al previsualizar PDF:', e);
              this.$bvToast.toast('No se pudo abrir el PDF', { title: 'Error', variant: 'danger', solid: true });
            }
          },
          cerrarPreviewPDF() {
            URL.revokeObjectURL(this.pdfPreviewUrl);
            this.pdfPreviewUrl = null;
          },
          async guardarPediente(similaresAceptados = false){

            if(!similaresAceptados)
              await this.convertToBase64();

            //Comprobar el total con el proveedor si ya existe.
            //al nombre del documento añadir el numero.
            
            let error = false;
            
            if(this.inputProveedor == '')
            {
              this.$bvToast.toast(`No se ha seleccionado el proveedor.`, {
              title: 'Faltan datos',
                      variant: 'danger',
                      solid: true,
                    })

              error = true;
            }

            if(this.inputCantidad == '')
            {
              this.$bvToast.toast(`No se ha rellenado la cantidad.`, {
              title: 'Faltan datos',
                      variant: 'danger',
                      solid: true,
                    })

              error = true;
            }

            if(this.inputCodigo == '')
            {
              this.$bvToast.toast(`No se ha rellenado el codigo.`, {
              title: 'Faltan datos',
                      variant: 'danger',
                      solid: true,
                    })

              error = true;
            }

            if(this.inputFecha == '')
            {
              this.$bvToast.toast(`No se ha seleccionado la fecha.`, {
              title: 'Faltan datos',
                      variant: 'danger',
                      solid: true,
                    })

              error = true;
            }

            if(error)
              return;

            if(this.itemSelect != null && this.base64PDF == '' && this.itemSelect.pdfFactura)
            {
              this.base64PDF = this.itemSelect.pdf;
            }

            //Fecha vencimiento
            this.inputFechaVencimiento = '';

            if(this.inputPlazo == '')
              this.inputPlazo = '0';
            else if (isNaN(parseInt(this.inputPlazo))) {
              this.inputPlazo = '0';
            }

            /*if(this.inputPlazo.length == '')
            {
              this.inputPlazo = '0';
            }*/

            var fechaActual = new Date(this.inputFecha);
            fechaActual.setDate(fechaActual.getDate() + parseInt(this.inputPlazo));
            const dia = fechaActual.getDate().toString().padStart(2, '0');
            const mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0');
            const anio = fechaActual.getFullYear().toString();
            this.inputFechaVencimiento = `${anio}-${mes}-${dia}`;

            let data = {
                id: this.idEdit,
                idEmpresa: this.inputEmpresa.id,
                idProveedor: this.inputProveedor.id,
                fechaFactura: this.inputFecha,
                codigo: this.inputCodigo,
                total: this.inputCantidad,
                fechaVencimiento: this.inputFechaVencimiento,
                plazo: this.inputPlazo,
                notas: this.inputNotas,
                nombreEmpresa: this.inputEmpresa.nombre,
                proveedor: this.inputProveedor.nombre,
                pdf: this.base64PDF,
                fechaPagado: '',
                pendiente: this.inputPendiente,
                pdfFactura: this.inputPdfFactura,
                tienePdf: this.base64PDF && this.base64PDF.length > 10 ? 1 : (this.itemSelect && this.itemSelect.tienePdf ? 1 : 0),
                moneda: this.selectedCurrency
            }        

            let similares = "";

            if(!similaresAceptados)
            {
              //agregar fecha a la comprobacion
                          
              this.listadoFacturas.forEach(gasto => {
                if(gasto.total == data.total && gasto.idEmpresa == data.idEmpresa && gasto.idProveedor == data.idProveedor && gasto.codigo.replaceAll(' ','') == data.codigo.replaceAll(' ',''))
                {
                  similares += gasto.codigo + '<br>';
                }
              });
            }

            if(!similaresAceptados && similares != '' && data.id == 0)
            {
              this.$swal({
                title: 'Existes estos gastos con los mismos datos',
                html: `Gastos similares:<br>${similares}`,
                icon: 'error',
                showCancelButton: true,
                //html: `<input type="text" id="motivo" class="swal2-input" placeholder="Motivo">`,
                confirmButtonText: 'Si, continuar',
                cancelButtonText: 'No',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
              }).then(result => {

                if(result.isConfirmed)
                  this.guardarPediente(true)
              })
            }
            else
            {
              function updatePedido(idGasto, lista){

                lista.forEach(pedido => {

                  if(pedido.check)
                  {
                    pedido.listaMateriales.forEach(element => {
                      if(element.cantidadFacturada != undefined && element.cantidadFacturada != '')
                        element.cantidadFacturada = parseInt(element.cantidadFacturada);
                      else
                        element.cantidadFacturada = element.cantidad;
                    });

                    let data = {
                      id: pedido.id,
                      idGasto,
                      lista: pedido.listaMateriales
                    }

                    pedido.idGasto = idGasto;

                    axios
                    .put("/materiales/pedidos/enlazarGasto", data)
                    .then(response => {
                        return response.data;
                    })
                    .then(res => {

                    });
                  }

                });

              }

                if(data.id == 0)
                {
                  axios
                    .post("/finanzas/gastos", data)
                    .then(response => {
                        return response.data;
                    })
                    .then(res => {

                        data.id = res.insertId;

                        updatePedido(data.id, this.listadoPedidosMostrar );

                        this.listadoPedidosMostrar.forEach(pedido => {

                          if(pedido.check)
                          {
                            const index = this.listadoPedidos.findIndex(pedidoActualizar => pedidoActualizar.id === pedido.id);
                            if (index !== -1) {
                              this.listadoPedidos[index].idGasto = data.id;
                            }

                          }
                          
                        });

                        this.listadoFacturas.unshift(data);

                       
                        this.$bvModal.hide('modal-add');

                        this.buscarFuncion(this.listadoFacturas);

                        //this.refetchEvents();
                        /*this.fetchCalendarOptions();
                        this.fetchCalendarsColor();*/

                        this.$swal({
                            icon: 'success',
                            title: data.codigo,
                            text: 'Se ha agregado correctamente.',
                            customClass: {
                            confirmButton: 'btn btn-success',
                            },
                        })
                    })
                    .catch(error=> {
                      console.log(error);
                      this.$swal({
                            icon: 'error',
                            title: 'Se ha producito un error.',
                            text: 'Prueba a escribir el codigo a mano.',
                            customClass: {
                            confirmButton: 'btn btn-danger',
                            },
                        })
                    });
                  }
                else{

                  axios
                    .put("/finanzas/gastos", data)
                    .then(response => {
                        return response.data;
                    })
                    .then(res => {

                      data.fechaPagado = this.itemSelect.fechaPagado;

                      updatePedido(data.id, this.listadoPedidosMostrar);

                      this.listadoFacturas.forEach((element, index) => {
                          if (element.id == data.id) {
                              this.listadoFacturas[index] = data;
                          }
                      });

                      this.listadoPedidosMostrar.forEach(pedido => {

                        if(pedido.check)
                        {
                          const index = this.listadoPedidos.findIndex(pedidoActualizar => pedidoActualizar.id === pedido.id);
                          if (index !== -1) {
                            this.listadoPedidos[index].idGasto = data.id;
                          }

                        }

                      });

                      this.$bvModal.hide('modal-add');

                      //this.refetchEvents();
                      //this.fetchCalendarOptions();
                      //this.fetchCalendarsColor();

                      this.buscarFuncion(this.listadoFacturas);

                      this.$swal({
                        icon: 'success',
                        title: data.codigo,
                        text: 'Se ha actualizado correctamente.',
                        customClass: {
                        confirmButton: 'btn btn-success',
                        },
                      })
                    });

                }                
            }
          },
          editarFechaPagadoSwal(data){

            this.$swal({
                title: 'Seleccionar nueva fecha. YYYY-MM-DD',
                icon: 'info',
                input: "text",              
                //inputValue: data.fechaPagado || new Date().toISOString().substr(0, 10),
                inputAttributes: {
                  type: 'date',
                },  
                showCancelButton: true,              
                confirmButtonText: 'Si, guardar',
                cancelButtonText: 'No',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
              }).then(result => {

                if(result.isConfirmed)
                {

                  axios
                    .put("/finanzas/gastos/fechapagado", {fechaPagado: result.value, id: data.id})
                    .then(response => {
                      return response.data;
                    })
                    .then(res => {
                        this.facturasBusqueda.forEach(item => {
                          if(item.id == data.id)
                            item.fechaPagado = result.value;
                        });
                        this.calcularResumen();
                      });


                }

              })            
          },
          clickPagado(estado, id){

            axios
              .put("/finanzas/gastos/pagado", {pagado: estado, id})
              .then(response => {
                return response.data;
              })
              .then(res => {
                  this.facturasBusqueda.forEach(item => {
                    if(item.id == id)
                      item.fechaPagado = res;
                  });

                  this.listadoFacturas.forEach(item => {
                    if(item.id == id)
                      item.fechaPagado = res;
                  });
                  this.calcularResumen();
                });
          },
          buscarFuncion(items = this.listadoFacturas ){

            this.mostrarTrimestres = false;

            let auxSorting = JSON.parse(JSON.stringify(items));

            this.facturasBusqueda = [];

            let aux = auxSorting.filter(factura => {
              const pagadoCondicion = 
                this.pagadoSelect === "Todos" ||
                (this.pagadoSelect === "Sin Pagar" && factura.fechaPagado === '') ||
                (this.pagadoSelect === "Pagado" && factura.fechaPagado !== '');    
    
              const empresaCondicion = this.empresaSelect.id === 0 || this.empresaSelect.id === factura.idEmpresa;
              const proveedorCondicion = this.proveedorSelect.id === 0 || this.proveedorSelect.id === factura.idProveedor;
    
              const textoCondicion = factura.codigo.toLowerCase().includes(this.buscar.toLowerCase()) || factura.proveedor.toLowerCase().includes(this.buscar.toLowerCase())
              || factura.nombreEmpresa.toLowerCase().includes(this.buscar.toLowerCase()) || (factura.cifProveedor && factura.cifProveedor.toLowerCase().includes(this.buscar.toLowerCase()))
              || (factura.textoPdf && factura.textoPdf.toLowerCase().includes(this.buscar.toLowerCase()))
              || (this.textoProveedor[factura.idProveedor] || '').includes(this.buscar.toLowerCase());
    
              const fechaDesdeCondicion = !this.fechaDesdeSelect || new Date(factura.fechaFactura) >= new Date(this.fechaDesdeSelect);
              const fechaHastaCondicion = !this.fechaHastaSelect || new Date(factura.fechaFactura) <= new Date(this.fechaHastaSelect);
    
              return pagadoCondicion && textoCondicion && empresaCondicion && proveedorCondicion && fechaDesdeCondicion && fechaHastaCondicion ;
            });

            // Array para objetos con fechaPagado vacía
            const objetosSinFechaPagado = aux.filter(objeto => !objeto.fechaPagado);

            objetosSinFechaPagado.sort((a, b) => {
              const dateA = new Date(a.fechaVencimiento);
              const dateB = new Date(b.fechaVencimiento);
              return dateA - dateB;
            });

            // Array para objetos con fechaPagado definida
            const objetosConFechaPagado = aux.filter(objeto => {
              if(Date.parse(objeto.fechaPagado))
                return objeto.fechaPagado;
              else
                return false;
            });

            // Ordenar objetos con fechaPagado definida por fechaPagado
            objetosConFechaPagado.sort((a, b) => {
              const dateA = new Date(a.fechaPagado);
              const dateB = new Date(b.fechaPagado);
              return dateB - dateA;
            });

            const objetosConFechaPagadoNoFecha = aux.filter(objeto => {
              // Verificar si fechaPagado está definido y no es una fecha válida
              return objeto.fechaPagado && isNaN(Date.parse(objeto.fechaPagado));
            });

            // Concatenar los dos arrays para obtener el resultado final
            const resultadoFinal = [...objetosSinFechaPagado, ...objetosConFechaPagado, ...objetosConFechaPagadoNoFecha];

            //this.facturasBusqueda = resultadoFinal;

            this.allFacturasBusqueda = resultadoFinal;

            this.facturasBusqueda = resultadoFinal.slice(0,this.countItemView);

            this.calcularResumen();

            this.calcularTrimestre();
          },
          downloadExcell(){
            var csv = "Empresa;Proveedor;Codigo;Fecha;IVA;Total;Falta;Vencimiento;Plazo;Notas;Pagado"+"\n";

            this.allFacturasBusqueda.forEach(factura => {         
              let iva = parseFloat(factura.total)-(parseFloat(factura.total)/1.21);
              iva = iva.toFixed(2);
                csv += factura.nombreEmpresa + ";" + factura.proveedorCompleto + ";" + factura.codigo + ";" + factura.fechaFactura+ ";"  + iva+ ";" 
                + factura.total+ ";" + factura.pendiente+ ";" + factura.fechaVencimiento+ ";" + factura.plazo + ";" + factura.notas+";" + factura.fechaPagado+"\n";
            });

            var encodedUri = encodeURI(csv);
            var link = document.createElement("a");
            link.setAttribute("href", 'data:text/csv;charset=utf-8,'+encodedUri);
            link.setAttribute("download", "gastos_proveedor.csv");
            document.body.appendChild(link); 
            link.click();
          },
          recalcularDatos()
          {
            this.cargarColumnas();

            this.buscarFuncion();
          },
          calcularResumen() {
            let facturas = 0;
            let pendienteDineroEuro = 0;
            let cobradoDineroEuro = 0;
            let totalEuro = 0;

            this.allFacturasBusqueda.forEach(item => {
              facturas++;

              let importeTotal = parseFloat(item.total);
              let pagadoTotal = parseFloat(item.total) - parseFloat(item.pendiente);
              if (item.pendiente !== '')
                importeTotal = parseFloat(item.pendiente);

              // Usar EUR como default si moneda es null/undefined
              const moneda = item.moneda ?? 'EUR';
              const factorCambio = this.tiposCambioAEuro[moneda] || 1;
              const importeEnEuros = importeTotal * factorCambio;

              if (item.fechaPagado === '') {
                pendienteDineroEuro += importeEnEuros;
                if(item.pendiente != '')
                {
                  cobradoDineroEuro += pagadoTotal * factorCambio;
                }                
                
              } else {                
                cobradoDineroEuro += importeEnEuros;
              }

              totalEuro += importeEnEuros;
            });


            this.dataResumen[0].valor = facturas;
            /*this.dataResumen[1].valor = pendienteDineroEuro.toFixed(2);
            this.dataResumen[2].valor = cobradoDineroEuro.toFixed(2);
            this.dataResumen[3].valor = totalEuro.toFixed(2);*/

            this.dataResumen[1].valor = pendienteDineroEuro.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
            this.dataResumen[2].valor = cobradoDineroEuro.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
            this.dataResumen[3].valor = totalEuro.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\./g, 'temp').replace(/,/g, '.').replace(/temp/g, ',');
    
          },
          guardarFiltro(){

            let datos = {
              pagado: this.pagadoSelect,
              desde: this.fechaDesdeSelect,
              hasta: this.fechaHastaSelect,
              empresa: this.empresaSelect,
              proveedor: this.proveedorSelect,
              buscar: this.buscar
            }

            const date = new Date();
            let hours = 12;
            date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
            const expires = "expires=" + date.toUTCString();
            document.cookie = 'gastosProveedor' + "=" + JSON.stringify(datos) + ";" + expires + ";path=/";

          },
          cargarFiltro(){

            let datos = null;

            const nameEQ = 'gastosProveedor' + "=";
            const cookiesArray = document.cookie.split(';');
            for(let i = 0; i < cookiesArray.length; i++) {
                let cookie = cookiesArray[i];
                while (cookie.charAt(0) == ' ') cookie = cookie.substring(1, cookie.length);
                if (cookie.indexOf(nameEQ) == 0) {
                  datos =  JSON.parse(cookie.substring(nameEQ.length, cookie.length));
                }
            }

            if(datos != null)
            {
                this.pagadoSelect = datos.pagado;
                this.fechaDesdeSelect = datos.desde;
                this.fechaHastaSelect = datos.hasta;
                if(datos.empresa && datos.empresa.id != null) {
                  const emp = this.empresas.find(e => e.id === datos.empresa.id);
                  if(emp) this.empresaSelect = emp;
                }
                if(datos.proveedor && datos.proveedor.id != null) {
                  const prov = this.proveedores.find(p => p.id === datos.proveedor.id);
                  if(prov) this.proveedorSelect = prov;
                }
                this.buscar = datos.buscar;
            }

          },
          editarFechaPagado(factura) {
            this.facturaActual = factura;
            this.nuevaFechaPagado = factura.fechaPagado || new Date().toISOString().substr(0, 10);

            this.$refs.modalFechaPagado.show();
          },
          focusInput() {
            this.$nextTick(() => {
              const el = document.getElementById('input-fecha');
              if (!el) return;

              if (typeof el.showPicker === 'function') {
                el.showPicker();
                return;
              }

              el.focus();
              el.click();
            });
          },
          guardarFechaPagado(){

            axios
              .put("/finanzas/gastos/fechapagado", {fechaPagado: this.nuevaFechaPagado, id: this.facturaActual.id})
              .then(response => {
                return response.data;
              })
              .then(res => {
                  this.facturasBusqueda.forEach(item => {
                    if(item.id == this.facturaActual.id)
                      item.fechaPagado = this.nuevaFechaPagado;
                  });
                  this.$swal({
                        icon: 'success',
                        title: 'Se ha actualizado la fecha de pago correctamente',
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                    })
                  this.calcularResumen();
                }).catch(error => {
                  console.error("Error al actualizar la fecha de pago:", error);
                  this.$swal({
                        icon: 'error',
                        title: 'Se ha producido un error al actualizar la fecha de pago.',
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                    })
                });

            /*console.log(this.facturaActual.fechaPagado);
            console.log(this.nuevaFechaPagado);*/

          },
          calcularTrimestre(){

            let anyo = this.anyoTrimestre;

            let trimestres = [
              {
                nombre: 'Enero-Febrero-Marzo',
                total: 0
              },
              {
                nombre: 'Abril-Mayo-Junio',
                total: 0
              },
              {
                nombre: 'Julio-Agosto-Septiembre',
                total: 0
              },
              {
                nombre: 'Octubre-Noviembre-Diciembre',
                total: 0
              }
            ]

            let items = JSON.parse(JSON.stringify(this.listadoFacturas));

            items.forEach(factura => {

              const proveedorCondicion = this.proveedorSelect.id === factura.idProveedor;
              const anyoCondicion = factura.fechaFactura.includes(anyo);

              if(proveedorCondicion && anyoCondicion)
              {
                if(factura.fechaFactura.includes('-01-') || factura.fechaFactura.includes('-02-') || factura.fechaFactura.includes('-03-'))
                {
                  trimestres[0].total +=  parseFloat(factura.total);
                }
                else if(factura.fechaFactura.includes('-04-') || factura.fechaFactura.includes('-05-') || factura.fechaFactura.includes('-06-'))
                {
                  trimestres[1].total +=  parseFloat(factura.total);
                }
                else if(factura.fechaFactura.includes('-07-') || factura.fechaFactura.includes('-08-') || factura.fechaFactura.includes('-09-'))
                {
                  trimestres[2].total +=  parseFloat(factura.total);
                }
                else if(factura.fechaFactura.includes('-10-') || factura.fechaFactura.includes('-11-') || factura.fechaFactura.includes('-12-'))
                {
                  trimestres[3].total +=  parseFloat(factura.total);
                }
                
              }

            });

            this.dataTrimestre = trimestres;

            if(this.proveedorSelect.id != 0)
              this.mostrarTrimestres = true;

          },
          calcular347(){
            let resultado = [];

            this.proveedores.forEach(proveedor => {
              if(proveedor.id === 0) return;

              let proveedorData = this.listadoProveedores.find(p => p.id === proveedor.id);
              let cif = proveedorData && proveedorData.cif ? proveedorData.cif : '';

              let data = { nombre: proveedor.nombre, cif: cif, trimestre1: 0, trimestre2: 0, trimestre3: 0, trimestre4: 0, total: 0 };

              this.listadoFacturas.forEach(factura => {
                if(proveedor.id !== factura.idProveedor) return;
                if(!factura.fechaFactura.includes(this.anyo347)) return;

                let importe = parseFloat(factura.total);
                if(factura.fechaFactura.includes('-01-') || factura.fechaFactura.includes('-02-') || factura.fechaFactura.includes('-03-'))
                  data.trimestre1 += importe;
                else if(factura.fechaFactura.includes('-04-') || factura.fechaFactura.includes('-05-') || factura.fechaFactura.includes('-06-'))
                  data.trimestre2 += importe;
                else if(factura.fechaFactura.includes('-07-') || factura.fechaFactura.includes('-08-') || factura.fechaFactura.includes('-09-'))
                  data.trimestre3 += importe;
                else if(factura.fechaFactura.includes('-10-') || factura.fechaFactura.includes('-11-') || factura.fechaFactura.includes('-12-'))
                  data.trimestre4 += importe;

                data.total += importe;
              });

              if(data.total >= 3005.06)
                resultado.push(data);
            });

            resultado.sort((a, b) => b.total - a.total);
            this.data347 = resultado;
          },
          copiar347(){
            let csv = "Proveedor;CIF;T1;T2;T3;T4;Total\n";
            this.data347.forEach(p => {
              csv += p.nombre + ";" + p.cif + ";" + p.trimestre1.toFixed(2) + ";" + p.trimestre2.toFixed(2) + ";" + p.trimestre3.toFixed(2) + ";" + p.trimestre4.toFixed(2) + ";" + p.total.toFixed(2) + "\n";
            });
            // Fila de totales
            let t = this.total347;
            csv += "TOTAL;;" + t.t1.toFixed(2) + ";" + t.t2.toFixed(2) + ";" + t.t3.toFixed(2) + ";" + t.t4.toFixed(2) + ";" + t.total.toFixed(2) + "\n";

            navigator.clipboard.writeText(csv).then(() => {
              this.$bvToast.toast('Datos del 347 copiados al portapapeles', { title: 'Copiado', variant: 'success', solid: true });
            }).catch(() => {
              this.$bvToast.toast('Error al copiar', { title: 'Error', variant: 'danger', solid: true });
            });
          },
          descargar347CSV(){
            let csv = "Proveedor;CIF;T1;T2;T3;T4;Total\n";
            this.data347.forEach(p => {
              csv += p.nombre + ";" + p.cif + ";" + p.trimestre1.toFixed(2) + ";" + p.trimestre2.toFixed(2) + ";" + p.trimestre3.toFixed(2) + ";" + p.trimestre4.toFixed(2) + ";" + p.total.toFixed(2) + "\n";
            });
            let t = this.total347;
            csv += "TOTAL;;" + t.t1.toFixed(2) + ";" + t.t2.toFixed(2) + ";" + t.t3.toFixed(2) + ";" + t.t4.toFixed(2) + ";" + t.total.toFixed(2) + "\n";

            let blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            let link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'modelo_347_' + this.anyo347 + '.csv';
            link.click();
          },
          copiarTrimestres(){

            var csv = "Empresa;1 Trimestre;2 Trimestre;3 Trimestre;4 Trimestre;Total"+"\n";          

            let proveedores346 = [];

            this.proveedores.forEach(proveedor => {
              let dataProveedor = {nombre: proveedor.nombre,trimestre1:0,trimestre2:0,trimestre3:0,trimestre4:0,total:0};
              this.listadoFacturas.forEach(factura => {

                const proveedorCondicion = proveedor.id === factura.idProveedor;
                const anyoCondicion = factura.fechaFactura.includes(this.anyoTrimestre);

                if(proveedorCondicion && anyoCondicion)
                {
                  if(factura.fechaFactura.includes('-01-') || factura.fechaFactura.includes('-02-') || factura.fechaFactura.includes('-03-'))
                  {
                    dataProveedor.trimestre1 +=  parseFloat(factura.total);
                    dataProveedor.total +=  parseFloat(factura.total);
                  }
                  else if(factura.fechaFactura.includes('-04-') || factura.fechaFactura.includes('-05-') || factura.fechaFactura.includes('-06-'))
                  {
                    dataProveedor.trimestre2 +=  parseFloat(factura.total);
                    dataProveedor.total +=  parseFloat(factura.total);
                  }
                  else if(factura.fechaFactura.includes('-07-') || factura.fechaFactura.includes('-08-') || factura.fechaFactura.includes('-09-'))
                  {
                    dataProveedor.trimestre3 +=  parseFloat(factura.total);
                    dataProveedor.total +=  parseFloat(factura.total);
                  }
                  else if(factura.fechaFactura.includes('-10-') || factura.fechaFactura.includes('-11-') || factura.fechaFactura.includes('-12-'))
                  {
                    dataProveedor.trimestre4 +=  parseFloat(factura.total);
                    dataProveedor.total +=  parseFloat(factura.total);
                  }
                  
                }
              });

              proveedores346.push(dataProveedor);
            });

           
            proveedores346.forEach(proveedor => {
              if(proveedor.total >= 3005.06)
              {
                csv += proveedor.nombre + ";" + proveedor.trimestre1.toFixed(2) + ";" + proveedor.trimestre2.toFixed(2) + ";" + proveedor.trimestre3.toFixed(2) + ";"
                + proveedor.trimestre4.toFixed(2) + ";" + proveedor.total.toFixed(2) + "\n";
              }
            });

            navigator.clipboard.writeText(csv).then(() => {
              this.$bvToast.toast('Datos copiados al portapapeles', {
                title: 'Copiado',
                variant: 'success',
                solid: true,
              });
            }).catch(() => {
              this.$bvToast.toast('Error al copiar al portapapeles', {
                title: 'Error',
                variant: 'danger',
                solid: true,
              });
            });

          }
        },
         mounted() {
          this.loadItems();
          setTimeout(()=>{
            this.cargando = false;
          }, 2000);
        },    
        watch: {
          buscar(){
            if(this.buscar == "")
              this.countItemView = this.defaultItemView;
            this.buscarFuncion();
            this.guardarFiltro();
          },
          pagadoSelect(){
            this.sortBy = null;
            this.buscarFuncion();
            this.guardarFiltro();
          },
          categoriaSelect(){
            this.sortBy = null;
            this.buscarFuncion();
            this.guardarFiltro();
          },
          proveedorSelect(){
            this.sortBy = null;
            this.buscarFuncion();
            this.guardarFiltro();
          },
          anyoTrimestre(){
            this.calcularTrimestre();
          },
          anyo347(){
            this.calcular347();
          },
          empresaSelect(){            
            this.sortBy = null;
            this.buscarFuncion();
            this.guardarFiltro();
          },
          fechaDesdeSelect(){
            this.buscarFuncion();
            this.guardarFiltro();
          },
          fechaHastaSelect(){
            this.buscarFuncion();
            this.guardarFiltro();
          },
          inputProveedor(){
            if(this.inputProveedor != null){

              if(this.inputProveedor.plazo != null)
                this.inputPlazo = this.inputProveedor.plazo;
              else
                this.inputPlazo = '';
              
              if(this.inputProveedor.empresa != null)
              {
                //let empresaEncontrada = this.empresasGastos.find(objeto => objeto.nombre.includes(this.inputProveedor.empresa));
                const empresaEncontrada = this.empresasGastos.find(objeto => objeto.alias === this.inputProveedor.empresa);
                
                if(empresaEncontrada)
                {
                  this.inputEmpresa = empresaEncontrada;
                }
              }

              this.listadoPedidosMostrar = [];
              /*this.listadoPedidosMostrar = this.listadoPedidos
              .filter(item => item.idProveedor == this.inputProveedor.id && item.idGasto === null)
              .map(item => ({ ...item, check: false }));*/

              this.listadoPedidos.forEach(pedido => {
                if(pedido.idProveedor == this.inputProveedor.id && pedido.fechaPedido != "")
                {

                  pedido.listaMateriales.map(item => ({ ...item, visible: true }));

                  let valido = false;
                  if(pedido.idGasto === null)
                    valido = true;
                  else
                  {

                    pedido.listaMateriales.forEach(material => {
                      if(material.cantidadFacturada == undefined || material.cantidadFacturada == "")
                        valido = true;
                      else if(material.cantidadFacturada < material.cantidad)
                        valido = true;
                    });

                  }

                  pedido.check = false;

                  if(valido)
                  {
                    this.listadoPedidosMostrar.push(pedido);

                    this.listadoPedidosMostrar.forEach(pedido => {
                      pedido.listaMateriales.forEach(material => {
                        if(material.cantidadFacturada !== undefined && material.cantidadFacturada == material.cantidad)
                          material.visible = false;
                        else
                          material.visible = true;
                      });

                    });
                  }

                }
              });

            }
            else{
              this.inputPlazo = '';
              this.listadoPedidosMostrar = [];
            }

            this.guardarFiltro();
              

          },
          event(){
            let facturaEncontrada = this.listadoFacturas.find(factura => factura.id == this.event.id);

            if (facturaEncontrada) {
              this.editFactura(facturaEncontrada);
            } else {
                //console.log('No se encontró la factura');
            }
          }
        },
        setup() {

           /* const CALENDAR_APP_STORE_MODULE_NAME = 'calendar'

            // Register module
            if (!store.hasModule(CALENDAR_APP_STORE_MODULE_NAME)) store.registerModule(CALENDAR_APP_STORE_MODULE_NAME, calendarStoreModule)

            // UnRegister on leave
            onUnmounted(() => {
              if (store.hasModule(CALENDAR_APP_STORE_MODULE_NAME)) store.unregisterModule(CALENDAR_APP_STORE_MODULE_NAME)
            })

            const {
              refCalendar,
              isCalendarOverlaySidebarActive,
              event,
              clearEventData,
              addEvent,
              updateEvent,
              removeEvent,
              fetchEvents,
              refetchEvents,
              calendarOptions,
              fetchCalendarsColor,

              // ----- UI ----- //
              isEventHandlerSidebarActive,
            } = useCalendar()

            const { fetchCalendarOptions } = useCalendarSidebar();

            fetchEvents()

            return {
              refCalendar,
              isCalendarOverlaySidebarActive,
              event,
              clearEventData,
              addEvent,
              updateEvent,
              removeEvent,
              refetchEvents,
              calendarOptions,
              fetchCalendarOptions,
              fetchCalendarsColor,

              // ----- UI ----- //
              isEventHandlerSidebarActive,
            }*/
          },
      }
    </script>
    
    <style lang="scss">
    @import '../@core/scss/vue/libs/chart-apex.scss';
    @import '../@core/scss/vue/libs/vue-select.scss';
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
    @import "@core/scss/vue/apps/calendar.scss";

    .ocultar-div { display: none; }

    .table-pedidos { margin-top: 10px; }
    .button-details:hover { cursor: pointer; }
    .cantidad-p { margin-bottom: 0px; }
    .cantidad-p:hover { cursor: pointer; }
    .button-icono:hover { cursor: pointer; }

    .bg-light-pepito {
      background: rgba(255, 159, 67, 0.12) !important;
      color: #ff9f43 !important;
      border-color: rgba(255, 159, 67, 0.1);
    }

    .table-warning td, .table-success td, .table-danger td {
      color: black !important;
    }

    .dark-layout {
      .table-warning td, .table-success td, .table-danger td {
        color: #d0d2d6 !important;
      }

      .table-warning,
      .table-warning > td,
      .table-warning > th {
        background-color: rgba(255, 159, 67, 0.15) !important;
      }

      .table-success,
      .table-success > td,
      .table-success > th {
        background-color: rgba(40, 199, 111, 0.15) !important;
      }

      .table-danger,
      .table-danger > td,
      .table-danger > th {
        background-color: rgba(234, 84, 85, 0.15) !important;
      }
    }

    .gp__pdf-preview {
      width: 100%;
      height: 80vh;
      border: 0;
      display: block;
    }

    .modal-347-body {
      min-height: 40vh;
      max-height: 80vh;
      overflow-y: auto;
    }

    /* ═══ Tabla global styles ═══ */
    .gp__table {
      margin-bottom: 0;

      thead th {
        background: #f8f9fb !important;
        border-bottom: 2px solid #e9ecf1 !important;
        border-top: none !important;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: #8a8e99;
        padding: 12px 14px;
        white-space: nowrap;
      }

      tbody td {
        padding: 10px 14px;
        vertical-align: middle;
        border-bottom: 1px solid #f0f1f4 !important;
        border-top: none !important;
        font-size: 13px;
        color: #5e5873;
        white-space: nowrap;
      }

      tbody tr {
        transition: background 0.15s;
        background: transparent !important;

        &:hover {
          background: #f9f8ff !important;
        }
      }
    }

    .dark-layout {
      .gp__resumen-card {
        background: #242424 !important;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;
      }
      .gp__resumen-card--primary,
      .gp__resumen-card--warning,
      .gp__resumen-card--danger,
      .gp__resumen-card--success,
      .gp__resumen-card--info {
        background: #242424 !important;
      }

      .gp__resumen-valor {
        color: #d0d2d6 !important;
      }

      .gp__resumen-label {
        color: #b4b7bd !important;
      }

      .gp__trimestres {
        background: #242424 !important;
      }

      .gp__trimestre-valor {
        color: #d0d2d6 !important;
      }

      .gp__trimestre-label {
        color: #b4b7bd !important;
      }

      .gp__filters {
        background: #242424 !important;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;
      }

      .gp__filter-label {
        color: #b4b7bd !important;
      }

      .gp__search-input {
        background: #242424 !important;
        border-color: #333 !important;
        color: #d0d2d6 !important;

        &::placeholder {
          color: #676d7d !important;
        }
      }

      .gp__table-card {
        background: #242424 !important;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;
      }

      .gp__table {
        thead th {
          background: #2e2e2e !important;
          border-bottom-color: #333 !important;
          color: #b4b7bd !important;
        }

        tbody td {
          color: #d0d2d6 !important;
          border-bottom-color: #333 !important;
        }

        tbody tr:hover {
          background: #2e2e2e !important;
        }
      }

      .gp__btn-icon {
        background: #242424 !important;
        border-color: #333 !important;
        color: #b4b7bd !important;
      }

      .gp__action--edit { background: #1e3a2a !important; }
      .gp__action--pdf { background: #2a2640 !important; }
      .gp__action--pdf-otros { background: #3a1e1e !important; }
      .gp__action--delete { background: #3a1e1e !important; }
      .gp__action--view { background: #1a3540 !important; }

      .gp__pagado--no {
        background: #3a1e1e !important;
        color: #ea5455 !important;
      }
    }
    </style>

    <style scoped>
    /* ═══ Resumen ═══ */
    .gp__resumen {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      margin-bottom: 14px;
      justify-content: center;
    }

    .gp__resumen-card {
      flex: 1;
      min-width: 180px;
      background: #fff;
      border-radius: 14px;
      padding: 20px 22px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
      transition: transform 0.2s, box-shadow 0.2s;
      border-left: none;
    }
    .gp__resumen-card:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    }
    .gp__resumen-card--primary { border-left-color: #7367f0; background: linear-gradient(135deg, #faf9ff 0%, #fff 100%); }
    .gp__resumen-card--warning { border-left-color: #ff9f43; background: linear-gradient(135deg, #fffcf7 0%, #fff 100%); }
    .gp__resumen-card--danger  { border-left-color: #ea5455; background: linear-gradient(135deg, #fff8f8 0%, #fff 100%); }
    .gp__resumen-card--success { border-left-color: #28c76f; background: linear-gradient(135deg, #f6fff6 0%, #fff 100%); }
    .gp__resumen-card--info    { border-left-color: #00cfe8; background: linear-gradient(135deg, #f5fdff 0%, #fff 100%); }

    .gp__resumen-icon {
      width: 50px;
      height: 50px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      flex-shrink: 0;
    }
    .gp__resumen-icon--primary { background: #eeedfd; color: #7367f0; }
    .gp__resumen-icon--warning { background: #fff3e0; color: #ff9f43; }
    .gp__resumen-icon--danger  { background: #fce4e4; color: #ea5455; }
    .gp__resumen-icon--success { background: #e8fce8; color: #28c76f; }
    .gp__resumen-icon--info    { background: #e0f4ff; color: #00cfe8; }

    .gp__resumen-valor {
      font-size: 19px;
      font-weight: 600;
      color: #3b4253;
      line-height: 1.2;
    }

    .gp__resumen-label {
      font-size: 12px;
      font-weight: 500;
      color: #8a8e99;
      margin-top: 3px;
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }

    /* ═══ Trimestres ═══ */
    .gp__trimestres {
      background: #fff;
      border-radius: 14px;
      padding: 18px 22px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
      margin-bottom: 14px;
    }

    .gp__trimestres-cards {
      display: flex;
      gap: 16px;
      flex-wrap: wrap;
      justify-content: center;
    }

    .gp__trimestre-card {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;
      min-width: 180px;
    }

    .gp__trimestre-icon {
      width: 46px;
      height: 46px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 700;
      flex-shrink: 0;
    }
    .gp__trimestre-icon--primary { background: #eeedfd; color: #7367f0; }
    .gp__trimestre-icon--success { background: #e8fce8; color: #28c76f; }
    .gp__trimestre-icon--warning { background: #fff3e0; color: #ff9f43; }
    .gp__trimestre-icon--info    { background: #e0f4ff; color: #00cfe8; }

    .gp__trimestre-valor {
      font-size: 15px;
      font-weight: 700;
      color: #3b4253;
    }

    .gp__trimestre-label {
      font-size: 12px;
      color: #8a8e99;
      margin-top: 2px;
    }

    .gp__trimestres-controls {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      margin-top: 14px;
    }

    .gp__trimestre-select {
      width: 120px;
    }

    /* ═══ Main container ═══ */
    .gp__main {
      display: flex;
      flex-direction: column;
      gap: 14px;
    }

    /* ═══ Filtros ═══ */
    .gp__filters {
      display: flex;
      align-items: flex-end;
      gap: 12px;
      background: #fff;
      border-radius: 14px;
      padding: 16px 20px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
      flex-wrap: wrap;
    }

    .gp__filter-item {
      display: flex;
      flex-direction: column;
      gap: 4px;
      flex: 1;
      min-width: 130px;
    }

    .gp__filter-item--wide {
      flex: 1.5;
      min-width: 180px;
    }

    .gp__filter-label {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: #8a8e99;
      margin-bottom: 0;
    }

    .gp__filter-buttons {
      display: flex;
      align-items: flex-end;
      gap: 8px;
      margin-left: auto;
      padding-bottom: 2px;
    }

    .gp__date-wrap {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .gp__date-clear {
      background: none;
      border: none;
      color: #b0b5c0;
      cursor: pointer;
      font-size: 13px;
      padding: 4px;
      transition: color 0.2s;
    }
    .gp__date-clear:hover {
      color: #ea5455;
    }

    /* ═══ Botones ═══ */
    .gp__btn-fab {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      border: none;
      background: linear-gradient(135deg, #28c76f 0%, #48da89 100%);
      color: #fff;
      font-size: 18px;
      cursor: pointer;
      box-shadow: 0 4px 14px rgba(40, 199, 111, 0.4);
      transition: all 0.2s;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .gp__btn-fab:hover {
      transform: scale(1.1);
      box-shadow: 0 6px 20px rgba(40, 199, 111, 0.5);
    }

    .gp__btn-icon {
      width: 36px;
      height: 36px;
      border-radius: 10px;
      border: 1px solid #dfe3e8;
      background: #fff;
      color: #6e6b7b;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      transition: all 0.2s;
    }
    .gp__btn-icon:hover {
      background: #7367f0;
      color: #fff;
      border-color: #7367f0;
    }

    /* ═══ Buscador ═══ */
    .gp__search {
      position: relative;
    }

    .gp__search-icon {
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-50%);
      color: #b0b5c0;
      font-size: 14px;
      z-index: 1;
    }

    .gp__search-input {
      width: 100%;
      padding: 12px 16px 12px 42px;
      border: 1px solid #e9ecf1;
      border-radius: 14px;
      font-size: 14px;
      color: #3b4253;
      background: #fff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
      transition: all 0.2s;
      outline: none;
    }
    .gp__search-input:focus {
      border-color: #7367f0;
      box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.12);
    }
    .gp__search-input::placeholder {
      color: #c0c4cc;
    }

    /* ═══ Tabla card ═══ */
    .gp__table-card {
      background: #fff;
      border-radius: 14px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
      overflow: hidden;
    }

    .gp__tabla-scroll {
      width: 100%;
      overflow-x: auto;
    }

    /* ═══ Acciones tabla ═══ */
    .gp__actions {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .gp__action {
      width: 28px;
      height: 28px;
      border-radius: 7px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.15s;
      font-size: 13px;
    }

    .gp__action--edit { color: #28c76f; background: #e8fce8; }
    .gp__action--edit:hover { background: #28c76f; color: #fff; }

    .gp__action--pdf { color: #7367f0; background: #eeedfd; }
    .gp__action--pdf:hover { background: #7367f0; color: #fff; }

    .gp__action--pdf-otros { color: #ea5455; background: #fce4e4; }
    .gp__action--pdf-otros:hover { background: #ea5455; color: #fff; }

    .gp__action--delete { color: #ea5455; background: #fce4e4; }
    .gp__action--delete:hover { background: #ea5455; color: #fff; }

    .gp__action--view { color: #00cfe8; background: #e0f4ff; }
    .gp__action--view:hover { background: #00cfe8; color: #fff; }

    /* ═══ Pagado ═══ */
    .gp__pagado {
      cursor: pointer;
      font-size: 13px;
      font-weight: 600;
      display: inline-flex;
      align-items: center;
      gap: 4px;
    }

    .gp__pagado--no {
      color: #ea5455;
      background: #fce4e4;
      padding: 3px 10px;
      border-radius: 20px;
    }

    .gp__pagado--si {
      color: #28c76f;
    }

    .gp__pagado-edit {
      cursor: pointer;
      margin-left: 8px;
      color: #8a8e99;
      transition: color 0.15s;
    }
    .gp__pagado-edit:hover {
      color: #7367f0;
    }

    /* ═══ Notas ═══ */
    .gp__nota-icon {
      color: #28c76f;
      cursor: pointer;
    }

    /* ═══ Total moneda ═══ */
    .gp__total-moneda {
      font-weight: 600;
    }
    </style>